(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsl-back-to-top"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('loy-back-to-top')) {
    customElements.define('loy-back-to-top', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.threshold = Number(this.dataset.threshold) || 600;
        this.scrollTarget = window;
        for (let parent = this.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
          if (/(auto|scroll)/.test(getComputedStyle(parent).overflowY)) {
            this.scrollTarget = parent;
            break;
          }
        }
        this.onScroll = () => {
          if (this.frame != null) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateVisibility();
          });
        };
        this.onClick = () => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollTarget.scrollTo({ top: 0, behavior: reduceMotion ? 'instant' : 'smooth' });
        };
        this.onFullscreen = () => this.updateVisibility();
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        document.addEventListener('fullscreenchange', this.onFullscreen);
        this.button.addEventListener('click', this.onClick);
        this.updateVisibility();
      }
      updateVisibility() {
        const offset = this.scrollTarget === window ? window.scrollY : this.scrollTarget.scrollTop;
        this.button.hidden = offset < this.threshold || Boolean(document.fullscreenElement);
      }
      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, true);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('fullscreenchange', this.onFullscreen);
        if (this.button) this.button.removeEventListener('click', this.onClick);
        if (this.frame != null) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsl-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      root.querySelectorAll('[data-bsl-nav-dropdown]').forEach((details) => {
        if (details.dataset.dropdownReady) return;
        details.dataset.dropdownReady = 'true';
        const summary = details.querySelector('summary');
        const header = details.closest('[data-bsl-header]');
        const hover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 901px)');
        let closeTimer;
        let openedByHover = false;
        const close = (restoreFocus = false) => {
          window.clearTimeout(closeTimer);
          openedByHover = false;
          details.open = false;
          if (restoreFocus) summary.focus();
        };
        const open = () => {
          window.clearTimeout(closeTimer);
          header.querySelectorAll('[data-bsl-nav-dropdown][open]').forEach((other) => {
            if (other !== details) other.open = false;
          });
          details.open = true;
        };
        details.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && hover.matches) {
            openedByHover = !details.open;
            open();
          }
        });
        summary.addEventListener('click', (event) => {
          if (hover.matches && openedByHover && event.detail > 0) {
            event.preventDefault();
            openedByHover = false;
            open();
          }
        });
        details.addEventListener('pointerleave', () => {
          if (!hover.matches) return;
          closeTimer = window.setTimeout(() => {
            if (!details.matches(':focus-within')) close();
          }, 160);
        });
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          header.querySelectorAll('[data-bsl-nav-dropdown][open]').forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
        details.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!details.contains(document.activeElement)) close();
          }, 0);
        });
        document.addEventListener('pointerdown', (event) => {
          if (details.isConnected && !details.contains(event.target)) close();
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            close(true);
          }
        });
        hover.addEventListener('change', () => close());
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
    } else {
      setup(document);
    }
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
